import { StatusBar } from "expo-status-bar";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { useFonts } from "expo-font";
import * as SplashScreen from "expo-splash-screen";
import { useCallback, useState, useEffect } from "react";
import { StyleSheet, ScrollView, Text } from "react-native";
import Intro from "./components/Intro";
import Select from "./components/Select";
import Quiz from "./components/Quiz";
import OkScreen from "./components/OkScreen";
import Wrong from "./components/Wrong";

SplashScreen.preventAutoHideAsync();

const generateRandomArray = () => {
  const array = [];

  for (let i = 0; i < 180; i++) {
    array.push(1);
  }

  // Shuffle the array using Fisher-Yates algorithm
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

export default function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [showSelect, setShowSelect] = useState(false);
  const [selectedNo, setSelectedNo] = useState(0);
  const [showWrong, setShowWrong] = useState(false);
  const [isOk, setIsOk] = useState(false);
  const [showDate, setShowDate] = useState("");

  const [fontsLoaded] = useFonts({
    Agriculture: require("./assets/fonts/Agriculture-Bold.otf"),
  });

  const checkListOfNo = async () => {
    const randomArray = generateRandomArray();
    const date = new Date();
    date.setHours(date.getHours() - 20);
    setShowDate(`${date.getHours()}:${date.getMinutes()}`);
    console.log(date);
    const storedArray = await AsyncStorage.getItem("randomArray");
    console.log(storedArray);
    if (storedArray) {
      const parsedArray = JSON.parse(storedArray);
      if (parsedArray.day === date.getDay()) {
        return;
      }
    }

    await AsyncStorage.setItem(
      "randomArray",
      JSON.stringify({
        day: date.getDay(),
        array: randomArray,
      })
    );
  };
  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      await SplashScreen.hideAsync();
      checkListOfNo().catch((err) => {
        console.log(err);
      });
    }
  }, [fontsLoaded]);

  if (!fontsLoaded) {
    return null;
  }

  return (
    <ScrollView style={styles.container} onLayout={onLayoutRootView}>
      {showSplash && (
        <Intro
          onOpen={() => {
            setShowSelect(true);
            setShowSplash(false);
          }}
        />
      )}
      {showSelect && (
        <Select
          onOpen={(value) => {
            setShowSelect(false);
            setSelectedNo(value);
          }}
        />
      )}
      {selectedNo > 0 && !showWrong && !isOk && (
        <Quiz
          selectedNo={selectedNo}
          isOk={() => {
            setIsOk(true);
          }}
          isWrong={() => {
            setShowWrong(true);
          }}
          onOpen={(selectedNo) => {
            setShowSelect(false);
            setSelectedNo(selectedNo);
          }}
        />
      )}
      {isOk && (
        <OkScreen
          selectedNo={selectedNo}
          onOpen={() => {
            setIsOk(false);
            setShowSelect(false);
            setSelectedNo(0);
            setShowSplash(true);
          }}
        />
      )}
      {showWrong && (
        <Wrong
          selectedNo={selectedNo}
          onOpen={() => {
            setIsOk(false);
            setShowSelect(false);
            setSelectedNo(0);
            setShowWrong(false);
            setShowSplash(true);
          }}
        />
      )}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#b8cd70",
    fontFamily: "Agriculture",
    fontWeight: "bold",
  },
});
